export const WEB_SOCKET_CHANNEL_PREFIX = 'API::V3::';

export enum WebSocketChannel {
  INCIDENTS = `IncidentsChannel`,
  MATCH_SCORE = 'MatchChannel',
}

export const getChannel = (channel: WebSocketChannel): string =>
  WEB_SOCKET_CHANNEL_PREFIX + channel;

export type WebSocketSubscription<T> = {
  command: 'subscribe' | 'unsubscribe';
  identifier: WebSocketChannelIdentifier<T>;
};

export type WebSocketChannelIdentifier<T = undefined> = {
  channel: string;
} & T;

export interface IncidentsChannelIdentifier {
  match_id: string;
}
